export enum CapitalizationDialogTab {
  Overview = 0,
  PriorPartials = 1,
}
